import request from '@/utils/request'

export function getChannelGroupList(params) {
  return request({
    url: 'notice/channel_group',
    method: 'get',
    params
  })
}

export function getSingleChannelGroup(id) {
  return request({
    url: 'notice/channel_group/' + id,
    method: 'get'
  })
}

export function createChannelGroup(id, data) {
  return request({
    url: 'notice/channel_group',
    method: 'post',
    data
  })
}

export function updateChannelGroup(id, data) {
  return request({
    url: 'notice/channel_group/' + id,
    method: 'put',
    data
  })
}

export function deleteChannelGroup(data) {
  return request({
    url: 'notice/channel_group/' + data,
    method: 'delete'
  })
}
